<template>
  <div class="header" :class="{ shadow: shadow }">
    <div class="logo" @click="toLink('/')"></div>

    <div class="header-btn-box" v-if="loadFlag">
      <div class="to-detail" v-if="courseOutlineUrl">
        <div class="img-mask" @click="toLink(courseOutlineUrl)">
          <img
            src="../../../assets/coursePage/common/Header/icon-toDetail.png"
            alt=""
          />
        </div>
        <div
          class="tip"
          v-if="tipFlag"
          :class="{ showTip: showTip }"
          @click.stop="() => false"
        >
          点击查看课程大纲
        </div>
      </div>
      <div class="header-btn">
        <a
          href="https://a.app.qq.com/o/simple.jsp?pkgname=com.boxuegu&utm_source=h5&utm_medium=boxuegu&utm_campaign=download&utm_content=topnavigation"
        >
          <div>下载APP</div>
        </a>
        <i v-if="!userPhoto" class="line"></i>
        <div v-if="!userPhoto" @click="toLink('/personalPage/personal')">
          登录
        </div>
      </div>
      <div
        class="photo"
        @click="toLink('/personalPage/personal')"
        v-if="userPhoto"
      >
        <img class="user-img" :src="userPhoto" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { IsAlive, getSkipUrl } from "../../../api/index.js";
import check from "../../../utils/check";
export default {
  data() {
    return {
      shadow: false,
      showTip: false,
      tipFlag: false,
      loadFlag: false,
      timer: null,
      userPhoto: "",
      courseOutlineUrl: "",
      courseList: [
        "ai",
        "java",
        "web",
        "architect",
        "py",
        "cpp",
        "pm",
        "dataAnalysis",
        "linux",
        "media",
        "newMedia",
        "test",
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    // 获取跳转详情页地址
    if (check.getUrlParam("nid")) {
      this.nid = check.getUrlParam("nid");
      this.getDetailUrl();
    }
    IsAlive()
      .then((res) => {
        if (res.success) {
          this.userPhoto = res.resultObject.smallHeadPhoto;
        }
      })
      .finally(() => {
        this.loadFlag = true;
      });
  },
  methods: {
    toLink(url) {
      window.location.href = url;
    },
    handleScroll() {
      this.$nextTick(() => {
        let scorllTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;

        if (scorllTop >= 1) {
          this.shadow = true;
        } else {
          this.shadow = false;
        }
      });
    },
    // 获取跳转详情页地址
    async getDetailUrl() {
      const params = {
        id: this.nid,
      };
      const res = await getSkipUrl(params);
      if (res.code == 200) {
        if (res.data) {
          this.courseOutlineUrl =
            res.data.courseOutlineUrl.indexOf("/coursePage") === -1
              ? ""
              : res.data.courseOutlineUrl;
          localStorage.setItem(
            `detail-${check.getUrlParam("nid")}`,
            this.courseOutlineUrl
          );
          if (this.courseOutlineUrl) {
            this.tipFlag = true;
            setTimeout(() => {
              this.showTip = true;
            }, 20);
            this.timer = setTimeout(() => {
              this.showTip = false;
              setTimeout(() => {
                this.tipFlag = false;
              }, 500);
            }, 8000);
          }
        } else {
          localStorage.removeItem(`detail-${check.getUrlParam("nid")}`);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 28px;
  padding-right: 32px;
  width: 100%;
  height: 88px;
  background: #ffffff;
  box-sizing: border-box;
  z-index: 100;

  .logo {
    width: 160px;
    height: 56px;
    background: url("../../../assets/coursePage/common/Header/logo@3x.png")
      no-repeat;
    background-size: cover;
  }

  .header-btn-box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-btn {
      height: 60px;
      background: #f1f6ff;
      border-radius: 32px;
      padding: 0 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      div {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #165dff;
        line-height: 36px;
      }

      i {
        width: 2px;
        height: 24px;
        background: #d8e6ff;
        margin: 0 18px;
      }
    }

    .photo {
      margin-left: 16px;

      .user-img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 2px solid #bedaff;
        box-sizing: border-box;
      }
    }

    .to-detail {
      // display: none;
      width: 60px;
      height: 60px;
      border-radius: 30px;
      position: relative;
      margin-right: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      .img-mask {
        width: 60px;
        height: 60px;
        background: rgba(22, 93, 255, 0.06);
        border-radius: 30px;
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 36px;
          height: 36px;
          position: relative;
          z-index: 2;
        }
      }
      .tip {
        cursor: default;
        position: absolute;
        right: -10px;
        bottom: 0px;
        width: 256px;
        height: 64px;
        line-height: 64px;
        text-align: center;
        background: #165dff;
        font-family: PingFang SC;
        font-size: 28px;
        font-weight: 400;
        color: #fff;
        border-radius: 8px;
        box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.06),
          0px 8px 20px 0px rgba(0, 0, 0, 0.08);
        transition: 0.5s all;
        opacity: 0;
        z-index: 1;

        &::after {
          position: absolute;
          top: -14px;
          right: 25px;
          content: "";
          width: 0;
          height: 0;
          border-left: 15px solid transparent;
          border-right: 15px solid transparent;
          border-bottom: 20px solid #165dff;
        }
      }

      .showTip {
        opacity: 1;
        bottom: -95px;
      }
    }
  }
}

.shadow {
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);
}
</style>
